import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import './css/register.css';

function Register() {
    const { handleRegister } = useAuth();
    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const onSubmit = (e) => {
        e.preventDefault();
        handleRegister({ name, lastname, email, password, confirmPassword });
    };

    return (
        <div className="container">
            <div className="form-container">
                <h2 className="form-title">REGISTRARSE</h2>
                <form onSubmit={onSubmit}>
                    <div className="input-group-container">
                        <div className="input-container">
                            <label className="label" htmlFor="name">Nombre</label>
                            <input
                                className="input"
                                id="name"
                                type="text"
                                placeholder="       Nombre"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <div className="input-container">
                            <label className="label" htmlFor="lastname">Apellido</label>
                            <input
                                className="input"
                                id="lastname"
                                type="text"
                                placeholder="       Apellido"
                                value={lastname}
                                onChange={(e) => setLastname(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="input-container">
                        <label className="label" htmlFor="email">Email</label>
                        <input
                            className="input"
                            id="email"
                            type="email"
                            placeholder="       Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="input-group-container">
                        <div className="input-container">
                            <label className="label" htmlFor="password">Contraseña</label>
                            <input
                                className="input"
                                id="password"
                                type="password"
                                placeholder="       Contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <div className="input-container">
                            <label className="label" htmlFor="confirmPassword">Confirmar contraseña</label>
                            <input
                                className="input"
                                id="confirmPassword"
                                type="password"
                                placeholder="       Confirmar contraseña"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="button-container">
                        <button className="button">
                            Registrarse
                        </button>
                    </div>
                </form>
                <p className="footer-form">
                    ¿Ya tienes cuenta? <Link to="/login" className="link">Inicia sesión</Link>
                </p>
            </div>
        </div>
    );
}

export default Register;
